export enum ChainFeature {
  STAKING = "staking",
}
